import { useState } from 'react';
import { Button } from './shared/button';
import { FaCog, FaClock } from 'react-icons/fa';

interface HeaderProps {
  isLoggedIn: boolean;
  onLogout: () => void;
  isLoginModalOpen: boolean;
  onProfileClick: () => void;
  onHistoryClick: () => void;
}

/**
 * Header Component
 *
 * A responsive header component that handles:
 * - Authentication state display
 * - Login/Logout actions
 * - Responsive design
 * - Visual feedback
 *
 * The header is hidden when the login modal is open to prevent
 * interaction conflicts and improve modal focus.
 */
export const Header: React.FC<HeaderProps> = ({
  isLoggedIn,
  onLogout,
  isLoginModalOpen,
  onProfileClick,
  onHistoryClick
}) => {
  if (isLoginModalOpen) {
    return null;
  }

  return (
    <header className="sticky top-0 z-50 w-full border-b border-gray-100 bg-white/80 backdrop-blur supports-[backdrop-filter]:bg-white/60">
      <div className="container flex h-16 max-w-3xl mx-auto items-center px-4">
        <div className="flex flex-1 items-center justify-end space-x-2">
          {isLoggedIn && (
            <>
              <button
                onClick={onHistoryClick}
                className="flex items-center gap-2 px-4 py-2 rounded-full border border-gray-300 bg-white text-gray-800 hover:bg-gray-100 transition-all duration-200"
                aria-label="History"
              >
                <FaClock className="w-5 h-5" />
              </button>
              <button
                onClick={onProfileClick}
                className="flex items-center gap-2 px-4 py-2 rounded-full border border-gray-300 bg-white text-gray-800 hover:bg-gray-100 transition-all duration-200"
                aria-label="Profile"
              >
                <FaCog className="w-5 h-5" />
              </button>
              <button
                onClick={onLogout}
                className="ml-2 px-4 py-2 rounded-full border border-gray-300 bg-white text-gray-800 hover:bg-gray-100 transition-all duration-200"
                aria-label="Logout"
              >
                Logout
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;